export default {"src":"/_next/static/media/linkedin.42dbab80.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};